import { UnidadeAdministrativaDto } from "src/app/pagamento/models/unidade-administrativa-dto";

export const UNIDADE_ADMINISTRATIVA_DTO: UnidadeAdministrativaDto[] = [
  { codigo: 128000, nome: "GOIÂNIA" },
  { codigo: 138000, nome: "CUIABÁ" },
  { codigo: 158000, nome: "PALMAS" },
  { codigo: 218000, nome: "SANTARÉM" },
  { codigo: 218100, nome: "MARABÁ" },
  { codigo: 230100, nome: "RIO BRANCO" },
  { codigo: 240100, nome: "MACAPÁ" },
  { codigo: 250100, nome: "PORTO VELHO" },
  { codigo: 260100, nome: "BOA VISTA" },
  { codigo: 310200, nome: "JUAZEIRO DO NORTE" },
  { codigo: 328000, nome: "SÃO LUIS" },
  { codigo: 338000, nome: "TERESINA" },
  { codigo: 410200, nome: "CARUARU" },
  { codigo: 428000, nome: "NATAL" },
  { codigo: 448000, nome: "MACEIÓ" },
  { codigo: 518000, nome: "FEIRA DE SANTANA" },
  { codigo: 528000, nome: "ARACAJU" },
  { codigo: 618000, nome: "GOVERNADOR VALADARES" },
  { codigo: 618100, nome: "JUIZ DE FORA" },
  { codigo: 618200, nome: "MONTES CLAROS" },
  { codigo: 718100, nome: "NITERÓI" },
  { codigo: 718200, nome: "NOVA IGUAÇU" },
  { codigo: 718300, nome: "RIO DE JANEIRO" },
  { codigo: 810200, nome: "ARAÇATUBA" },
  { codigo: 810300, nome: "BAURU" },
  { codigo: 810500, nome: "PRESIDENTE PRUDENTE" },
  { codigo: 810700, nome: "SÃO JOSÉ DO RIO PRETO" },
  { codigo: 811200, nome: "LIMEIRA" },
  { codigo: 812300, nome: "FRANCA" },
  { codigo: 812400, nome: "JUNDIAÍ" },
  { codigo: 812500, nome: "PIRACICABA" },
  { codigo: 818000, nome: "SÃO PAULO" },
  { codigo: 818100, nome: "CAMPINAS" },
  { codigo: 818200, nome: "RIBEIRÃO PRETO" },
  { codigo: 818300, nome: "SOROCABA" },
  { codigo: 818400, nome: "SANTO ANDRÉ" },
  { codigo: 828000, nome: "SÃO JOSÉ DOS CAMPOS" },
  { codigo: 910400, nome: "PONTA GROSSA" },
  { codigo: 918000, nome: "CURITIBA" },
  { codigo: 918100, nome: "CASCAVEL" },
  { codigo: 918200, nome: "MARINGÁ" },
  { codigo: 928000, nome: "JOINVILLE" },
  { codigo: 928100, nome: "BLUMENAU" },
  { codigo: 1018000, nome: "SANTA MARIA" },
  { codigo: 1018100, nome: "CAXIAS DO SUL" }
];